module.exports = __webpack_public_path__ + "static/media/pause.20aa2911.svg";